/**
 * Akcje historii
 *
 * @export
 * @enum {number}
 */
export enum HistoryAction {
  ADD = 'ADD',
  DELETE = 'DELETE',
  DOWNLOAD_MAIN_ATTACHMENT = 'DOWNLOAD_MAIN_ATTACHMENT',
  GET = 'GET',
  GET_EPUAP = 'GET_EPUAP',
  LOGIN = 'LOGIN',
  SEARCH = 'SEARCH',
  SEND_MAIL = 'SEND_MAIL',
  SET_STATUS = 'SET_STATUS',
  UPDATE = 'UPDATE'
}

/**
 * Tłumaczenia akcji historii
 *
 * @export
 * @enum {number}
 */
export enum HistoryActionTranslations {
  ADD = 'Dodanie',
  DELETE = 'Usunięcie',
  DOWNLOAD_MAIN_ATTACHMENT = 'Pobrano XML',
  GET = 'Pobranie',
  GET_EPUAP = 'Przygotowanie do wysyłki przez ePUAP',
  LOGIN = 'Logownaie',
  SEARCH = 'Wyszukanie',
  SEND_MAIL = 'Wysłano e-mail',
  SET_STATUS = 'Zmiana statusu',
  UPDATE = 'Aktualizacja'
}
